import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const articleSlugs = [
  "/what-is-oopbuy-spreadsheet",
  "/oopbuy-spreadsheet-review",
  "/oopbuy-spreadsheet-comparison",
  "/oopbuy-spreadsheet-beginner-guide",
  "/is-oopbuy-spreadsheet-safe",
  "/oopbuy-spreadsheet-tutorial",
  "/oopbuy-spreadsheet-tips",
  "/oopbuy-spreadsheet-features",
  "/why-oopbuy-spreadsheet-trending",
  "/oopbuy-spreadsheet-for-business",
  "/oopbuy-spreadsheet-mistakes",
  "/oopbuy-spreadsheet-pricing",
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...articleSlugs.map((slug) => ({
    path: slug,
    element: <ArticlePage />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;